import { convertLang } from './languageUtils.js';

(function () {
  const body = document.body;
  const newContent = `
    <div id="translate_menu_container">
      <ul id="translate_listul">
        <li id="translate_menu" data-stt-langbar>
          <a id="translate_lang" href="#" class="toggle-menu" data-stt-ignore><span>JP</span></a>
          <ul class="lang_dropdown">
            <li id="lang_description">This website uses an automatic machine translation service.</li>
            <li><a href="#" data-code="JA" data-value="ja" data-stt-changelang="ja" data-stt-ignore>JAPANESE</a></li>
            <li><a href="#" data-code="EN" data-value="en" data-stt-changelang="en" data-stt-ignore>ENGLISH</a></li>
          </ul>
        </li>
      </ul>
    </div>
  `;

  // メニューをDOMに挿入
  body.insertAdjacentHTML("afterbegin", newContent);

  const toggleMenu = body.querySelector(".toggle-menu");
  const dropdown = body.querySelector(".lang_dropdown");

  if (toggleMenu && dropdown) {
    toggleMenu.addEventListener("click", (event) => {
      event.preventDefault();
      dropdown.classList.toggle("open");
    });
  }

  const style = document.createElement("style");
  style.textContent = `
    #translate_menu_container {
      letter-spacing: normal;
    }
    #translate_listul {
      margin: 0;
      padding: 0;
    }
    #translate_listul ul {
      margin: 0;
      padding: 0;
    }
    #translate_menu_container li {
      margin: 0;
    }
    #translate_menu_container li {
      list-style: none;
    }
    #translate_menu_container {
      position: fixed;
      bottom: 0;
      right: 0;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      z-index: 999999;
    }
    #translate_lang {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 4px;
      color: #000;
      font-size: 11px;
      font-weight: 500;
      width: 59px;
      height: 29px;
      background: #DDD;
      line-height: 1;
      text-decoration: none !important;
    }
    @media (max-width: 768px) {
      #translate_lang {
        width: 56px;
        height: 50px;
        font-size: 13px;
      }
    }
    #translate_lang::before {
      content: url('data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.00004%2014.7879C11.7489%2014.7879%2014.7879%2011.7489%2014.7879%208.00004C14.7879%204.25119%2011.7489%201.21216%208.00004%201.21216C4.25119%201.21216%201.21216%204.25119%201.21216%208.00004C1.21216%2011.7489%204.25119%2014.7879%208.00004%2014.7879Z%22%20stroke%3D%22black%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.99998%201.21216C7.99998%201.21216%205.73877%201.21216%205.73877%208.00004C5.73877%2014.7879%207.99998%2014.7879%207.99998%2014.7879%22%20stroke%3D%22black%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8%201.21216C8%201.21216%2010.2612%201.21216%2010.2612%208.00004C10.2612%2014.7879%208%2014.7879%208%2014.7879%22%20stroke%3D%22black%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.4017%205.73877H1.61084%22%20stroke%3D%22black%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.4017%2010.2612H1.61084%22%20stroke%3D%22black%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3C%2Fsvg%3E');
    }
    #translate_menu {
      position: relative;
    }
    #translate_menu > li > .toggle-menu {
      text-decoration: none;
      cursor: pointer;
      color: #333;
    }
    #lang_description {
      font-size: 10px;
      color: #000;
      line-height: 1.1;
      padding: 7px 9px;
    }
    @media (max-width: 768px) {
      #lang_description {
        font-size: 12px;
        padding: 7px 11px;
      }
    }
    .lang_dropdown {
      width: 160px;
      display: none;
      position: absolute;
      bottom: 100%;
      right: 0;
      background: #DDD;
      line-height: 1;
      text-align: left;
    }
    @media (max-width: 768px) {
      .lang_dropdown {
        width: 193px;
      }
    }
    .lang_dropdown li {
      float: none !important;
    }
    .lang_dropdown a {
      text-decoration: none;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 1;
      height: 25px;
      font-weight: 400;
    }
    @media (max-width: 768px) {
      .lang_dropdown a {
        font-size: 14px;
        height: 40px;
      }
    }
    a[data-stt-active],
    .lang_dropdown a:hover {
      background-color: #FAF8ED;
      font-weight: bold;
    }
    .lang_dropdown.open {
      display: block;
    }
    .stt-lang-select.br {
      display: none;
    }
  `;
  document.head.appendChild(style);
})();

window.addEventListener("load", function () {
  // 初期ロード時の言語設定
  __stt.get('lang', function (lang) {
    const upperLang = convertLang(lang);
    const langElement = document.querySelector('#translate_lang');
    if (langElement) {
      langElement.textContent = upperLang;
    }
  });
});

// 言語変更時のクリックイベント
document.addEventListener('click', (event) => {
  const target = event.target;

  if (target && target.matches('[data-stt-changelang]')) {
    event.preventDefault();

    // クリックされた言語を取得
    const newLang = convertLang(target.getAttribute('data-stt-changelang'));

    // 言語を更新
    const langElement = document.querySelector('#translate_lang');
    if (langElement) {
      langElement.textContent = newLang;
    }

    // ドロップダウンを閉じる
    const dropdown = document.querySelector(".lang_dropdown");
    if (dropdown) {
      dropdown.classList.remove("open");
    }
  }
});
